<template>
  <div class="row">
    <div class="col">

      <!-- form new item -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">

                <!-- guest name -->
                <div class="col-md-5 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Nome do Hóspede</label>
                    <input class="form-control" type="text" placeholder="Nome do Hóspede" v-model="guest_name" required>
                  </div>
                </div>

                <!-- record_number -->
                <div class="col-md-5 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Número da Ficha</label>
                    <input class="form-control" type="text" placeholder="Número da Ficha" v-model="record_number" required>
                  </div>
                </div>

                <!-- total -->
                <div class="col-md-2 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Total</label>
                    <input class="form-control" type="number" v-model="total" required>
                  </div>
                </div>

                <!-- company id -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Empresa</label>
                    <v-select :options="filterCompanies" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="company_id" @input="validateCompany()" :disabled="_company ? true : false"></v-select>
                  </div>
                </div>

                <!-- contract -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Contrato</label>
                    <v-select :options="filterContracts" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="contract_id"></v-select>
                  </div>
                </div>

                <!-- work_place_id -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Local de Trabalho</label>
                    <v-select :options="filterWorkplaces" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="workplace_id" @input="validateWorkplace()"></v-select>
                  </div>
                </div>

                <!-- sublocal -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-sublocal">Sublocal</label>
                    <v-select :options="filterSublocal" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="sublocal_id" @input="loadSectors()"></v-select>
                  </div>
                </div>

                <!-- sector_id -->
                <div class="col-md-5 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-sector_id">Setor</label>
                    <v-select :options="filterSectors" label="name" :reduce="name => name.id" v-model="sector_id" @input="validateSector()"></v-select>
                  </div>
                </div>
                
                <!-- subsector_id -->
                <div class="col-md-5 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-subsector_id">Subsetor</label>
                    <v-select :options="filterSubsectors" :reduce="name => name.id" label="name" v-model="subsector_id"></v-select>
                  </div>
                </div>

                <div class="col-md-2 text-end" style="text-align:right;">
                  <button href="#" class="btn btn-success btn-block" :disabled="items.length == 0 ? true : false" style="height:40px;padding-top:7px;margin-top:35px;" @click="newData()">SALVAR</button>
                </div>
              
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row">

                <!-- observations -->
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-control-label" for="input-observations">Observações</label>
                    <textarea type="text" id="input-observations" class="form-control" placeholder="Observações" v-model="observations" rows="4" required="false"></textarea>
                  </div>
                </div>

                <!-- file -->
                <div class="col-md-10">
                  <div class="form-group">
                    <label class="form-control-label" for="input-file">Fotos</label>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" multiple id="file" name="file" ref="file" lang="pt" v-on:change="handleFileUpload">
                      <label class="custom-file-label" for="file">{{fileName}}</label>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <a href="#" class="btn btn-outline-success btn-block" style="margin-top: 29px;height: 40px;padding-top: 7px;" @click="storeItem()">Adicionar</a>
                </div>

                <!-- list files -->
                <div class="row p-3" v-if="files.length > 0">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-2 mb-3 position-relative" v-for="(file, index) in files" :key="index">
                        <button type="button"
                                class="btn btn-sm btn-danger text-white position-absolute"
                                style="top: -10px; right: -10px; border-radius: 50%; width: 24px; height: 24px; z-index: 10; padding: 0;"
                                @click.stop="removeImage(index)">
                          ×
                        </button>

                        <img :src="file.url"
                            class="img-thumbnail"
                            style="cursor: pointer;"
                            @click="openImageModal(file.url)" />

                        <small class="d-block text-truncate mt-1">{{ file.name }}</small>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="items.length > 0">
        <div class="col-md-12">

          <div class="card" v-for="(item, index) in items" :key="index" style="padding: 20px;">
            <div class="row">
              <div class="col-md-10">
                <h5 style="font-size:14px;"><b>Observações:</b><br/>{{ item.observations }}</h5>
              </div>
              <div class="col-md-2 text-end" style="text-align: right;">
                <button class="btn btn-sm btn-outline-danger" @click="deleteData(props.row.index)" title="Deletar"><i class="far fa-trash-alt"></i></button>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                  <div class="col-md-1 mb-3 position-relative" v-for="(file, indexFile) in item.files" :key="indexFile">
                    <img :src="file.url" class="img-thumbnail" style="cursor: pointer;" @click="openImageModal(file.url)" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div v-else class="text-center p-3 text-muted">
        <h5>Nenhum item adicionado!</h5>
      </div>
    </div>

    <!-- modal preview -->
    <div class="modal fade" id="imageModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content bg-transparent border-0">
          <div class="modal-body text-center p-0 position-relative">
            <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Fechar"></button>
            <img :src="selectedImage" v-if="selectedImage" class="img-fluid rounded shadow" />
          </div>
        </div>
      </div>
    </div>

    <vue-loading color="#212121" :active.sync="loading" :can-cancel="false" :is-full-page="fullPage"></vue-loading>
  </div>
</template>

<script>
import configData from "../../config.js";
import ApiService from '../../apiservice.js';
export default {
  mixins: [ApiService, configData],
  props: ["_company"],
  data() {
    return {
      guest_name: null,
      record_number: null,
      total: null,
      observations: null,
      company_id: null,
      contract_id: null,
      workplace_id: null,
      sublocal_id: null,
      sector_id: null,
      subsector_id: null,
      files: [],
      fileName: 'Selecione as fotos',
      items: [],
      filterCompanies: [],
      filterContracts: [],
      filterWorkplaces: [],
      filterSublocal: [],
      filterSectors: [],
      filterSubsectors: [],
      loading: false,
      fullPage: true,
      selectedImage: null
    }
  },
  mounted() {
    if(this._company){
      this.company_id = parseInt(this._company);
      this.validateCompany();
    }
    this.loadCompanies();
  },
  methods: {
    handleFileUpload() {
      const selectedFiles = this.$refs.file.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        const reader = new FileReader();

        reader.onload = (e) => {
          this.files.push({
            name: file.name,
            url: e.target.result
          });
        };
        reader.readAsDataURL(file);
      }
      this.fileName = `${selectedFiles.length} arquivo(s) selecionado(s)`;
    },
    deleteData(index) {
      this.items.splice(index, 1);
    },
    newData() {
      let _this = this;

      if(_this.items.length > 0){
        if(_this.company_id == null || _this.contract_id == null || _this.workplace_id == null || _this.sublocal_id == null || _this.sector_id == null || _this.subsector_id == null){
          _this.$swal({
            title: 'Atenção',
            text: 'Preencha todos os campos antes de salvar.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
        } else {
          _this.loading = true;

          let formData = new FormData();
          formData.append("guest_name", _this.guest_name);
          formData.append("record_number", _this.record_number);
          formData.append("total", _this.total);
				  formData.append("company_id", _this.company_id);
          formData.append("contract_id", _this.contract_id);
          formData.append("workplace_id", _this.workplace_id);
          formData.append("sublocal_id", _this.sublocal_id);
          formData.append("sector_id", _this.sector_id);
          formData.append("subsector_id", _this.subsector_id);
          formData.append("items", JSON.stringify(_this.items));

          axios.post("/portal/governance", formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((res) => {

            _this.loading = false;

            //call function in ApiService to validate success
            _this._api_validateSuccess(res,true);

          }).catch((err) => {

            _this.loading = false;

            if (err.response.data.errors){
              //set errors
              _this.errors = err.response.data.errors;
            }

            //call function in ApiService to validate error
            _this._api_validateError(err);

          });

        }
      }
      
    },
    openImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('imageModal'));
        modal.show();
      });
    },
    removeImage(index) {
      this.files.splice(index, 1);
      this.fileName = `${this.files.length} arquivo(s) selecionado(s)`;
    },
    storeItem() {
      if (this.observations && this.files.length > 0) {
        this.items.push({
          observations: this.observations,
          files: this.files
        });
        this.observations = null;
        this.files = [];
        this.fileName = 'Selecione as fotos';
      } else {
        
      }
    },
    loadCompanies() {
      let _this = this;
      axios.get("/admin/companies").then((res) => {
        res.data.sort(function(a, b){
          return a.corporate_name - b.corporate_name;
        });
        _this.filterCompanies = _this.filterCompanies.concat(res.data);
      }).catch((err) => {
      });
    },
    loadContracts() {
      let _this = this;
      _this.loading = true;
      _this.filterContracts = [];
      axios.get("/admin/companycontracts/"+_this.company_id+"/search").then((res) => {
        res.data.map((rowContract) => {
          _this.filterContracts.push({
            id: rowContract.contract_id,
            corporate_name: rowContract.contracts.corporate_name
          });
        });
        _this.filterContracts.sort(function(a, b){
          return a.corporate_name - b.corporate_name;
        });
        _this.loading = false;
      }).catch((err) => {
        _this.loading = false;
      });
    },
    loadSectors() {
      let _this = this;
      _this.loading = true;

      _this.filterSectors = [];

      axios.get("/admin/sectors/"+_this.sublocal_id+"/search").then((res) => {
        res.data.sort(function(a, b){
          return a.name - b.name;
        });
        _this.filterSectors = _this.filterSectors.concat(res.data);
        _this.loading = false;
      }).catch((err) => {
        _this.loading = false;
    });

    },
    validateCompany(){
      let _this = this;
      _this.loading = true;

      _this.filterWorkplaces = [];
      axios.get("/admin/companyworkplaces/"+_this.company_id+'/search').then((res) => {
        res.data.map((rowReturn) => {
          _this.filterWorkplaces = _this.filterWorkplaces.concat(rowReturn.work_places);
        });
        _this.filterWorkplaces.sort(function(a, b){
          return a.corporate_name - b.corporate_name;
        });
        _this.loadContracts();
      }).catch((err) => {
      });
      this.loading = false;
    },
    validateSector(){
      let _this = this;
      _this.filterSubsectors = [];
      _this.loading = true;
      axios.get("/admin/subsectors/"+_this.sublocal_id+"/search").then((res) => {
        res.data.map((rowSubsector) => {
          if(rowSubsector.sector_id == _this.sector_id){
            _this.filterSubsectors.push(rowSubsector);
          }
        });
        _this.loading = false;
      }).catch((err) => {
        _this.loading = false;
      });
    },
    validateWorkplace(){
      let _this = this;

      _this.filterSublocal = [];
      axios.get("/admin/workplacesublocal/"+_this.workplace_id+"/search").then((res) => {
        res.data.map((rowSublocal) => {
          _this.filterSublocal.push({
            corporate_name: rowSublocal.sublocal.corporate_name,
            id: rowSublocal.sublocal_id
          });
        });
        _this.loading = false;
      }).catch((err) => {
        _this.loading = false;
      });

    }
  }
}
</script>
